namespace RedBullMOBILE360.Web.API {
    export namespace CSTService {
        export const baseUrl = '~/api/CST';

        export declare function GetRegisteredNumbers(request: Web.Models.ArqamiRequest, onSuccess?: (response: Microsoft.AspNetCore.Mvc.IActionResult) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            GetRegisteredNumbers = "~/api/CST/GetRegisteredNumbers"
        }

        [
            'GetRegisteredNumbers'
        ].forEach(x => {
            (<any>CSTService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
